import { API_BASE } from "@/App";
import managedAxios from "@/utils/managedAxios";

/**
 * Section names mapping for display
 */
const SECTION_NAMES = {
  "/daily-intelligence": "News",
  "/prelims": "Prelims Hub",
  "/mains": "Mains Hub",
  "/prelims/mcq-practice": "MCQ Practice",
  "/prelims/pyq-analyzer": "PYQ Analyser",
  "/prelims/heatmap": "Heatmap",
  "/prelims/test-series": "Test Series",
  "/prelims/trap-detector": "Trap Detector",
  "/prelims/pattern-prediction": "Pattern Prediction",
  "/prelims/ca-converter": "CA Converter",
  "/prelims/csat-solver": "CSAT Solver",
  "/prelims/newspaper-converter": "Newspaper Converter",
  "/prelims/analytics": "Prelims Analytics",
  "/gs1-suite": "GS-I Suite",
  "/gs2-suite": "GS-II Suite",
  "/gs3-suite": "GS-III Suite",
  "/gs4-suite": "GS-IV Suite",
  "/essay-suite": "Essay Suite",
  "/csat-suite": "CSAT Suite",
  "/concept-intelligence": "Concept Intelligence",
  "/intelligence": "Intelligence Digests",
  "/pyq": "PYQ Analysis",
  "/tests": "Test Series",
  "/evaluation": "Evaluation",
  "/notes": "Notes",
  "/mentor": "AI Mentor",
  "/clarity": "Clarity Assistant",
  "/command": "Today's Command",
  "/progress-report": "Progress Report",
  "/diagnostic/gs": "GS Diagnostic",
  "/diagnostic/csat": "CSAT Diagnostic",
  "/expected": "Expected Questions",
  "/current-affairs": "Current Affairs",
  "/mains-revision": "Mains Revision",
  "/gamification": "Gamification",
  "/upgrade": "Upgrade",
};

/**
 * Track section visit to backend
 */
export const trackSectionVisit = async (path) => {
  const token = localStorage.getItem("token");
  if (!token) return;

  // Skip tracking for certain paths
  const skipPaths = ["/auth", "/login", "/landing", "/", "/dashboard", "/pricing"];
  if (skipPaths.includes(path)) return;

  const sectionName = SECTION_NAMES[path] || path.replace(/\//g, " ").trim() || "Unknown";

  try {
    await managedAxios.post(
      `${API_BASE}/analytics/track-section`,
      { section: sectionName, path },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.debug("Section tracking failed:", error.message);
  }
};

export default SECTION_NAMES;
